import * as React from "react";
const ArrowLeftIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.7002 7.51456H4.5002L10.1002 1.74822L8.7002 0.306641L0.700195 8.54426L8.7002 16.7819L10.1002 15.3403L4.5002 9.57397H16.7002V7.51456Z"
      fill="#373737"
    />
  </svg>
);
export default ArrowLeftIcon;
